import { Avatar, Dropdown, Menu } from '../index';
import React from 'react';

import '../global.less';
import './usermenu.scss';
import { UserOutlined } from '@ant-design/icons';

interface UserMenuProps {
    profileUrl?: string;
}

const UserMenu: React.FC<UserMenuProps> = (props) => {
    const menu = <Menu className="rain-user-menu">{props.children}</Menu>;

    return (
        <Dropdown className="rain-user-avatar" overlay={menu} trigger={['click']}>
            <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                <Avatar size={36} src={props.profileUrl} icon={!props.profileUrl && <UserOutlined />} />
            </a>
        </Dropdown>
    );
};

export default UserMenu;
